// extracted by mini-css-extract-plugin
module.exports = {"header-row":"HeaderRow_header-row__2YJbz","fuel-grade-cell":"HeaderRow_fuel-grade-cell__2lAAH"};